import styled from 'styled-components';

import {breakpoint, colors, font} from 'theme';

export const Title = styled.h1`
    margin: 0;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-transform: uppercase;
    color: ${colors.darkGrey};
`;

export const TypeStep = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    width: 100%;

    @media (max-width: ${breakpoint.tablet}) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export const TypeField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    max-width: 768px;
`;

export const TypeLabel = styled.p`
    margin: 0;
    font-family: ${font.family.primary};
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    color: ${colors.darkGrey};

    span {
        color: ${colors.danger};
    }
`;

export const TypeOptions = styled.div`
    display: flex;
    gap: 12px;
    width: 100%;

    @media (max-width: ${breakpoint.phone}) {
        flex-direction: column;
    }
`;

export const TypeOption = styled.button<{selected: boolean}>`
    flex: 1;
    min-width: 0;
    padding: 12px 40px;
    border-radius: 8px;
    border: 1px solid ${(p) => (p.selected ? colors.brandPrimary : colors.textMuted)};
    background: ${(p) => (p.selected ? '#F2F7FF' : colors.white)};
    color: ${(p) => (p.selected ? colors.brandPrimary : colors.textPrimary)};
    font-family: ${font.family.primary};
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    cursor: pointer;

    @media (max-width: ${breakpoint.tablet}) {
        padding: 12px 16px;
    }
`;

export const NextAction = styled.div`
    flex-shrink: 0;

    @media (max-width: ${breakpoint.tablet}) {
        align-self: flex-end;
    }
`;
